import { CoinModelRequest, DcaStrategy } from "@/types/dca";
import { get } from "lodash";
import { useTranslation } from "react-i18next";

export const useDcaValidation = () => {
  const { t } = useTranslation();

  const baseMinimumInvestment = 10;

  const validateInvestmentAmount = (investmentAmount: number, dca: DcaStrategy): string | true => {
    const coins: CoinModelRequest[] = get(dca, "coinModelRequest", []);
    const coinCount = coins.length;
    const minimumInvestmentAmount = coinCount * baseMinimumInvestment;

    if (investmentAmount < minimumInvestmentAmount) {
      return t("dca.minInvestment", { amount: minimumInvestmentAmount });
    }

    return true
  };

  const validateMinimumInvestment = (
    minimumInvestmentPerCoin: number,
    dca: DcaStrategy,
    isCreate?: boolean
  ): string | true => {
    const coins: CoinModelRequest[] = get(dca, "coinModelRequest", []);
    const investmentAmount = isCreate
      ? get(dca, "investedCapital", 0)
      : get(dca, "usdcBalance", 0);

    if (minimumInvestmentPerCoin > investmentAmount) {
      return t("dca.lessThanBalance")
    }

    const minimumInvestment = (baseMinimumInvestment * coins.length);

    if (minimumInvestmentPerCoin < minimumInvestment) {
      return t("dca.minPerCoin", { amount: minimumInvestment })
    }

    return true;
  };


  return { validateInvestmentAmount, validateMinimumInvestment };
};
